import { render, staticRenderFns } from "./DeleteConfirmationModal.vue?vue&type=template&id=2447dae4&scoped=true&"
import script from "./DeleteConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteConfirmationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2447dae4",
  null
  
)

export default component.exports